import {
  ApplicationRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  Inject,
  Injector,
  OnDestroy,
  OnInit,
  TemplateRef,
  Type,
  ViewChild
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

import { Cnp, MafFormControlComponent, Parser, ValidateResult } from 'maf-web';
import { AppService } from '../app.service';
import { ConsumidorSiteClientModelService } from '../service/consumidorsiteclient.model.service';
import { ParametrosModelService } from '../service/parametros.model.service';
import { ConsumidorSiteResponseChaveConfirmacaoValida, ConsumidorSiteResponseGetConsumidorV1APP, } from '../vo/sitevo.vo';
import { ListaComponent } from '../lojas/lista/lista.component';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['../app.css', './login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  private _componentRef: ComponentRef<ListaComponent> = null;
  srcLogo: string = '';
  fantasia: string = '';
  telefone: string = '';
  whatsApp: string = '';
  CPFConsumidor: string = '';
  chaveConfirmacao: string = '';
  dataConfirmacao: ConsumidorSiteResponseGetConsumidorV1APP;
  isValidCPF: ValidateResult = { valid: true };
  isValidConfirmacao: ValidateResult = { valid: true };
  isFormCPF: boolean = true;
  isFormConfirmacao: boolean = false;
  isLoading: boolean = false;
  isModalAjudaVendedores: boolean = false;

  @ViewChild('setFocusCPF', {static: false}) focusCPFElement: MafFormControlComponent;
  @ViewChild('setFocusConfirmacao', {static: false}) focusConfirmacaoElement: MafFormControlComponent;
  @ViewChild('divLoadComponent') divLoadComponent: ElementRef;

  constructor(
    private app: AppService,
    private consumidor: ConsumidorSiteClientModelService,
    private parametros: ParametrosModelService,
    private router: Router,
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    this.srcLogo = this.app.lojaLogoBase64;
    this.fantasia = this.app.lojaFantasia;
    this.telefone = this.app.lojaTelefone;
    this.whatsApp = this.app.lojaWhatsApp;
    window.parent.scroll(0, 0);
    this.setFocusCPF();
  }

  ngOnDestroy() {
    this.unloadComponent();
  }

  get isBtnNovoCadastro(): boolean {
    return this.CPFConsumidor.length === 14 && !this.isValidCPF.valid && this.app.cpfLoginParaCadastro === this.CPFConsumidor;
  }

  private setFocusCPF() {
    if (this.focusCPFElement) {
      this.focusCPFElement.setFocus();
    } else {
      const self = this;
      setTimeout(() => self.setFocusCPF(), 50);
    }
  }

  private setFocusConfirmacao() {
    if (this.focusConfirmacaoElement) {
      this.focusConfirmacaoElement.setFocus();
    } else {
      const self = this;
      setTimeout(() => self.setFocusConfirmacao(), 50);
    }
  }

  formatarTelefone(numero: string): string {
    return Parser.formataFone(numero);
  }

  buscaCPF(): boolean {
    if (!Cnp.isValidCPF(this.CPFConsumidor)) {
      this.isValidCPF = { valid: false, message: 'Parece ter algo errado no CPF.' };
      return false;
    }
    this.isLoading = true;
    this.consumidor.getConsumidor(this.CPFConsumidor)
      .then((data: ConsumidorSiteResponseGetConsumidorV1APP) => {
        if (data.clienteLocalizado && data.acessoAppPagtoParc) { // cliente localizado e com acesso
          this.app.consumidorSiteResponse = data;
          if (data.token != null && data.token.length > 0) {
            return this.app.setTokenEParametrosAPP(data.token, data.pkCliente, this.CPFConsumidor);
          } else {
            this.dataConfirmacao = data;
            this.isFormCPF = false;
            this.isFormConfirmacao = true;
            this.isValidConfirmacao = { valid: true };
            this.setFocusConfirmacao();
          }
        } else if (data.clienteLocalizado && ! data.acessoAppPagtoParc) { // cliente sem acesso
          this.isValidCPF = { valid: false, message: 'Erro de acesso ou CPF não encontrado.' };
          return false;
        } else { // cliente não localizado
          this.app.cpfLoginParaCadastro = this.CPFConsumidor;
          this.isValidCPF = { valid: false, message: 'CPF não encontrado na base de dados. Você pode criar um novo cadastro.' };
          return false;
        }
      })
      .catch(erro => console.error(erro))
      .then(() => this.isLoading = false);
  }

  validarChaveConfirmacao() {
    if (Parser.strToInt(this.chaveConfirmacao) === 0) {
      this.isValidConfirmacao = { valid: false, message: 'A chave informada não é valida.'};
      return;
    }
    this.isLoading = true;
    this.consumidor.isChaveConfirmacaoValida(this.CPFConsumidor, Parser.strToInt(this.chaveConfirmacao))
      .then((data: ConsumidorSiteResponseChaveConfirmacaoValida) => {
        if (data.chaveConfirmacaoValida) {
          return this.app.setTokenEParametrosAPP(data.token, data.pkCliente, this.CPFConsumidor);
        } else {
          this.isValidConfirmacao = { valid: false, message: 'A chave informada não é valida.'};
          return undefined;
        }
      })
      .catch(erro => console.error(erro))
      .then(() => this.isLoading = false);
  }

  mudarCPF() {
    this.dataConfirmacao = undefined;
    this.CPFConsumidor = '';
    this.chaveConfirmacao = '';
    this.isFormConfirmacao = false;
    this.isFormCPF = true;
  }

  ajudaWhatsApp() {
    const linkApi: string = this.app.isMobile ? 'api' : 'web';
    const a = document.createElement('a');
    a.target = '_blank';
    a.href = `https://${linkApi}.whatsapp.com/send?phone=55${this.whatsApp}&text=${encodeURI(`Olá, tudo bem?`)}`;
    a.click();
  }

  novoCadastro(): void {
    this.router.navigate(['/cadastro']);
  }

  ajudaVendedoresLoja(): void {
    this.isModalAjudaVendedores = true;
    const div = this.divLoadComponent.nativeElement;
    this._componentRef = this.app.loadComponent<ListaComponent>(ListaComponent, div);
  }

  fecharAjudaVendedoresLoja(): void {
    this.isModalAjudaVendedores = false;
    this.unloadComponent();
  }

  private unloadComponent(): void {
    if (this._componentRef != null) {
      const componentEl = this._componentRef.location.nativeElement;
      componentEl.parentNode.removeChild(componentEl);
      this._componentRef.destroy();
    }
    this._componentRef = null;
  }

}
